import { z } from "zod";
import { ROLES } from "./enums.js";
import { accountPreferencesSchema, passwordSchema } from "./contracts.js";
export const updateProfileInputSchema = z.object({
    name: z.string().trim().min(2).max(80)
});
export const inviteMemberInputSchema = z.object({
    email: z.email().transform((value) => value.toLowerCase()),
    role: z.enum(ROLES).exclude(["owner"]),
    workspaceIds: z.array(z.string().min(1)).min(1).max(50)
});
export const acceptInvitationInputSchema = z.object({
    name: z.string().trim().min(2).max(80).optional(),
    password: passwordSchema.optional()
});
export const ownerOnboardingInputSchema = z.object({
    organisationName: z.string().trim().min(2).max(100),
    workspaceName: z.string().trim().min(2).max(100),
    preferences: accountPreferencesSchema
});
export const invitedOnboardingInputSchema = z.object({
    name: z.string().trim().min(2).max(80),
    preferences: accountPreferencesSchema
});
export const membershipStatusInputSchema = z.object({
    status: z.enum(["active", "suspended"])
});
export const NOTIFICATION_KINDS = [
    "incident_assigned",
    "incident_updated",
    "incident_commented",
    "membership_added"
];
